import "./document-to-pdf.css";
import { parsePlainText } from "./document-pdf-core.js";
import { initializeDocumentPdfTool } from "./document-to-pdf-ui.js";

initializeDocumentPdfTool({ mode: "txt", parseSource: parsePlainText });
